import { CodeLabelSize, generateCodeLabelsPdf } from '@shared/utils/codeLabelPdf';

export type LabelSize = CodeLabelSize;

export async function generatePackingStationLocationLabelsPdf(codes: string[], labelSize: LabelSize): Promise<void> {
  const validCodes = codes.map((c) => c.trim()).filter(Boolean);
  if (validCodes.length === 0) return;

  const fileName =
    validCodes.length === 1
      ? `etiqueta_ubicacion_${validCodes[0]}_${Date.now()}.pdf`
      : `etiquetas_ubicaciones_${Date.now()}.pdf`;

  await generateCodeLabelsPdf({
    labels: validCodes.map((code) => ({ code })),
    labelSize,
    fileName,
  });
}
